import React, { Component } from "react";
import { Tag, Select, Radio } from "antd";

var _ = require("lodash");
const Option = Select.Option;

class PriorityFilterInput extends Component<{
  onFilterSet: (filter: any) => void;
  filterOptions: object;
  selectProps?: object;
}> {
  onChange = ele => {
    this.props.onFilterSet({ selectedOptions: ele });
  };

  render() {
    // console.log("PRORP", this.props);
    const radioStyle = {
      display: "block",
      height: "30px",
      lineHeight: "30px"
    };
    const _that = this;
    const { selectProps = {} } = _that.props;
    return (
      <span>
        <Select
          mode="multiple"
          style={{ width: "100%" }}
          placeholder="Please select"
          defaultValue={this.props.filterOptions["selectedOptions"]}
          onChange={this.onChange}
          {...selectProps}
        >
          {Object.keys(this.props.filterOptions["options"]).map(function(key) {
            return (
              <Option key={key} value={key}>
                {_that.props.filterOptions["options"][key]}
              </Option>
            );
          })}
        </Select>
      </span>
    );
  }
}

export default PriorityFilterInput;
